import React, { useMemo } from 'react';
import { SelectFieldTW } from 'tailwindComponents/selectTW/SelectFieldTW';
import { SelectOption } from 'tailwindComponents/selectTW/interfaces';
import { useListCorrectionReasonsQuery } from 'API/order/corrections/CorrectionsAPI';
import { getCorrectionReasons } from 'types/signingAppointment/ISigningTypeResponse';
import { labelComparator } from '../../../../../../utilities/labelComparator';

export const SelectCorrectionReasons: React.FC<{ isCorrection: boolean }> = ({ isCorrection }) => {
  const { data: correctionReasons = [] } = useListCorrectionReasonsQuery();

  const correctionReasonOptions: SelectOption[] | [] = useMemo(
    () => getCorrectionReasons(correctionReasons).toSorted(labelComparator),
    [correctionReasons]
  );
  if (!isCorrection) {
    return null;
  }

  return (
    <div className="flex">
      <SelectFieldTW
        isRequired
        isMultiple
        labelText={'Correction Reason(s)'}
        name={'correctionReasons'}
        placeholder={'Select a reason'}
        options={correctionReasonOptions}
      />
    </div>
  );
};
